import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.user',
        }
    },

    methods: {
        all() {
            return axios({
                method: 'get',
                url: route('api.users.index'),
                params: {
                    scopes: ['allRecords'],
                }
            })
            .then(response => response.data.data.data)
        }
    }
}